import {useState, useEffect} from 'react';
import { useDebounce } from '../../../../../hooks/useDebounce';
import { promiseHandler } from '../../../../../utils/promises';

export const useSearchResults = ({request = () => {}, resultExtractor = () => {}, defaultValue = 1}) => {
  const [input, setInput] = useState(defaultValue);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  const debouncedInput = useDebounce(input);

  useEffect(() => {
    const getResults = async () => {
      if(input?.length === 0) {
        return;
      }

      const {data: response, error} = await promiseHandler(request(debouncedInput));
      
      const normalizedResult = response?.data?.map(resultExtractor);

      setResults(normalizedResult);
      setIsLoading(false);
    }

    getResults();
  }, [debouncedInput]);

  useEffect(() => {
    if(!isLoading && input?.length > 0) {
      setIsLoading(true);
      setResults([]);
    }
  }, [input]);

  return {
    value: input,
    onChangeValue: setInput,
    isLoading,
    results
  }
}